/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_DescriptionInputs */

const en_admin_tickets_description = /** @type {(inputs: Admin_Tickets_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View and reply to user tickets`)
};

/**
* | output |
* | --- |
* | "View and reply to user tickets" |
*
* @param {Admin_Tickets_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_description = /** @type {((inputs?: Admin_Tickets_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_description(inputs)
});
export { admin_tickets_description as "admin.tickets.description" }